//图谱库
import React, {useEffect} from "react";
import {Button, Col, Form, Input, Layout, message, Modal, Pagination, Row, Space, Table, Tooltip} from "antd";
import {Content, Header} from "antd/es/layout/layout";
import styled from "styled-components";
import {useStore} from "../../../store";
import {ColumnsType} from "antd/es/table";
import {AtlasEntity} from "../../../entity/atlas-entity";
import {DetailType, ExcelUploadType} from "../../../common/Constant";
import {observer} from "mobx-react";
import UploadFile from "../../common/upload-file";
import {deleteAtlasRecord} from "../../../http/manager";
import ImageDetail from "./image-detail";
import ImageEdit from "./image-edit";
import {transaction} from "mobx";
import {ImageLibraryStore} from "../../../store/image-library.store";


const ImageLibrary: React.FC = () => {

    const {imageLibraryStore} = useStore()
    const [form] = Form.useForm();
    useEffect(() => {
        queryAtlasList({})
        return imageLibraryStore.clear()
    }, []);
    const columns:ColumnsType<AtlasEntity> = [
        {
            title: '序号',
            width: 70,
            dataIndex: 'id',
            key: 'id',
            align: "center",
            render: (value, record, index) => {
                return <div>{index + 1}</div>
            }
        },
        {
            title: '图谱编号',
            width: 100,
            dataIndex: 'atlasNumber',
            key: 'atlasNumber',
            align: "center",
        },
        {
            title: '采样编号',
            width: 100,
            dataIndex: 'sampleNumber',
            key: 'sampleNumber',
            align: "center",
        },
        {
            title: '药材名',
            width: 100,
            dataIndex: 'medicineName',
            key: 'medicineName',
            align: "center",
        },
        {
            title: '基原植物',
            width: 100,
            dataIndex: 'originalPlant',
            key: 'originalPlant',
            align: "center",
        },
        {
            title: '拉丁名',
            width: 200,
            dataIndex: 'latinName',
            key: 'latinName',
            align: "center",
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            ),
        },
        {
            title: '样品来源',
            width: 100,
            dataIndex: 'sampleSource',
            key: 'sampleSource',
            align: "center",
        },
        {
            title: '取样部位',
            width: 100,
            dataIndex: 'smapleLocation',
            key: 'smapleLocation',
            align: "center",
        },
        // {
        //     title: '样品提供单位',
        //     width: 100,
        //     dataIndex: 'sampleUnit',
        //     key: 'sampleUnit',
        //     align: "center",
        // },
        // {
        //     title: '鉴定人',
        //     width: 100,
        //     dataIndex: 'appraiser',
        //     key: 'appraiser',
        //     align: "center",
        // },
        // {
        //     title: '责任人',
        //     width: 100,
        //     dataIndex: 'dutyPerson',
        //     key: 'dutyPerson',
        //     align: "center",
        // },
        // {
        //     title: '序列提交时间',
        //     width: 100,
        //     dataIndex: 'sequenceTime',
        //     key: 'sequenceTime',
        //     align: "center",
        // },
        {
            title: '图谱类型',
            width: 100,
            dataIndex: 'atlasType',
            key: 'atlasType',
            align: "center",
        },
        {
            title: '操作',
            width: 240,
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            align: "center",
            render: (value, record) => {
                return <Space size="middle">
                    <Button onClick={() => toEditModal(record)} type={"primary"}>编辑</Button>
                    <Button onClick={() => toDetailModal(record)} type={"primary"}>详情</Button>
                    <Button onClick={() => openDeleteConfirm(record)} type={"primary"} danger={true}>删除</Button>
                </Space>
            }
        },
    ]

    const toEditModal = (record: AtlasEntity) => {
        imageLibraryStore.setDetailType(DetailType.EDIT)
        imageLibraryStore.detailEntity = record;
        imageLibraryStore.setShowEdit(true)
    }

    const toDetailModal = (record: AtlasEntity) => {
        imageLibraryStore.detailEntity = record
        imageLibraryStore.setShowDetail(true)
    }

    const openDeleteConfirm = (record: AtlasEntity) => {
        imageLibraryStore.isShowDeleteConfirm = true
        imageLibraryStore.deleteRecord = record
    }

    const onUploadClose = () => {
        imageLibraryStore.setShowUpload(false);
    }

    const openUploadFileModal = () => {
        imageLibraryStore.setShowUpload(true);
    }

    const openAddSpecimenModal = () => {
        imageLibraryStore.detailEntity = undefined
        imageLibraryStore.setShowEdit(true)
        imageLibraryStore.detailType = DetailType.ADD
    }

    const onQuery = () => {
        imageLibraryStore.requestAtlasInfoList(imageLibraryStore.condition)
    }

    const onReset = () => {
        imageLibraryStore.reset()
        form.setFieldsValue(imageLibraryStore.condition)
        imageLibraryStore.requestAtlasInfoList(imageLibraryStore.condition)
    }

    const onSizeChange = (page: number, pageSize: number) => {
        transaction(() => {
            imageLibraryStore.pagination.pageNum = page;
            imageLibraryStore.pagination.pageSize = pageSize
            imageLibraryStore.condition.pageNum = page;
            imageLibraryStore.condition.pageSize = pageSize
            queryAtlasList(imageLibraryStore.condition)
        })
    }

    const queryAtlasList = (params: {}) => {
        imageLibraryStore.requestAtlasInfoList(params);
    }

    const onUploadSuccess = () => {
        imageLibraryStore.setShowUpload(false);
        onReset()
    }

    const onDeleteConfirmClose = () => {
        imageLibraryStore.isShowDeleteConfirm = false;
    }

    const deleteButton = () => {
        if (!imageLibraryStore.deleteRecord) {
            return
        }
        const params = {
            id: imageLibraryStore.deleteRecord.id,
        }
        deleteBaseLibrary(params);
    }

    const deleteBaseLibrary = (params: any) => {
        deleteAtlasRecord(params)
            .then((res) => {
                if (Number(res.code) === 200) {
                    message.success("删除成功");
                    onDeleteConfirmClose();
                    onReset()
                } else {
                    if (res.message) {
                        message.error(res.message);
                    } else {
                        message.error("删除失败");
                    }
                }
            }).catch(() => {
            message.error("删除失败");
        })
    }

    const onEditSuccess = () => {
        imageLibraryStore.isShowEdit = false
        onReset()
    }
    const OnDetailModalClose = () => {
        imageLibraryStore.isShowDetail = false
    }

    const OnEditModalClose = () => {
        imageLibraryStore.isShowEdit = false
    }

    return (
        <Layout style={{display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
            <Header style={{background: "#ffffff", borderBottom: "1px solid #d3d3d3", padding: "0 0 0 0"}}>
                <TitleSpan>图谱库</TitleSpan>
            </Header>
            <Content style={{flex: 1, overflow: 'hidden'}}>
                <Wrapper>
                    <SearchWrapper>
                        <Space>
                            <Button onClick={openUploadFileModal} type={"primary"}
                                    style={{width: "100px", margin: "15px 0 15px 15px"}}
                                    size={"large"}>批量上传</Button>
                            <Button onClick={openAddSpecimenModal} type={"default"}
                                    style={{width: "100px", margin: "15px 0 15px 15px"}} size={"large"}>新建</Button>
                        </Space>
                        <Form form={form} labelAlign={"right"} wrapperCol={{span: "15"}}>
                            <Row justify={"space-between"} gutter={[15, 0]} style={{padding: "0 15px"}}>
                                <Col span={6}>
                                    <Form.Item labelCol={{span: "7"}} label={"图谱编号"} name={'atlasNumber'}><Input
                                        onChange={(e) => imageLibraryStore.condition.atlasNumber = e.target.value}
                                        value={imageLibraryStore.condition.atlasNumber}
                                        placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span: "7"}} label={"采样编号"} name={'sampleNumber'}><Input
                                        onChange={(e) => imageLibraryStore.condition.sampleNumber = e.target.value}
                                        value={imageLibraryStore.condition.sampleNumber}
                                        placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span: "7"}} label={"基原植物"} name={'originalPlant'}><Input
                                        onChange={(e) => imageLibraryStore.condition.originalPlant = e.target.value}
                                        value={imageLibraryStore.condition.originalPlant}
                                        placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span: "7"}} label={"拉丁名"} name={'latinName'}><Input
                                        onChange={(e) => imageLibraryStore.condition.latinName = e.target.value}
                                        value={imageLibraryStore.condition.latinName}
                                        placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span: "7"}} label={"药材名"} name={'medicineName'}><Input
                                        onChange={(e) => imageLibraryStore.condition.medicineName = e.target.value}
                                        value={imageLibraryStore.condition.medicineName}
                                        placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span: "7"}} label={"图谱类型"} name={'atlasType'}><Input
                                        onChange={(e) => imageLibraryStore.condition.atlasType = e.target.value}
                                        value={imageLibraryStore.condition.atlasType}
                                        placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    {/*<Form.Item labelCol={{span: "7"}} label={"图谱类型"} name={'atlasType'}><Input*/}
                                    {/*    onChange={(e) => imageLibraryStore.condition.atlasType = e.target.value}*/}
                                    {/*    value={imageLibraryStore.condition.atlasType}*/}
                                    {/*    placeholder={"请输入"}/></Form.Item>*/}
                                </Col>
                                <Col span={6} style={{paddingLeft: "25px"}}>
                                    <Space size={["middle", "large"]}>
                                        <Button onClick={onQuery} type={"primary"}>查询</Button>
                                        <Button onClick={onReset} type={"default"}>重置</Button>
                                        {/*<Button onClick={onResetOnclick} type={"primary"} danger={true}>批量删除</Button>*/}
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </SearchWrapper>
                    <ContentWrapper>
                        <Table
                            rowClassName={(type, index, intent) => {
                                return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                            }}
                            style={{margin: "15px 15px 0 15px"}}
                            size={"small"}
                            bordered={true}
                            dataSource={imageLibraryStore.dataSource}
                            columns={columns}
                            scroll={{x: true, y: '500px'}}
                            pagination={{position: [], pageSize: imageLibraryStore.pagination.pageSize}}
                        />
                        <Pagination
                            size={"small"}
                            style={{margin: "15px 15px 15px 0", alignSelf: "end"}}
                            total={imageLibraryStore.pagination.total}
                            showQuickJumper={true}
                            showSizeChanger={true}
                            defaultPageSize={10}
                            hideOnSinglePage={false}
                            onChange={onSizeChange}
                            current={imageLibraryStore.pagination.pageNum}
                        />
                    </ContentWrapper>
                </Wrapper>
                <Modal onCancel={OnDetailModalClose}
                       width={"700px"}
                       open={imageLibraryStore.isShowDetail}
                       closable={true}
                       centered={true}
                       footer={null}
                       title={"基础库详情"}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <ImageDetail/>
                </Modal>
                <Modal onCancel={OnEditModalClose}
                       width={"750px"}
                       open={imageLibraryStore.isShowEdit}
                       closable={true}
                       centered={true}
                       destroyOnClose={true}
                       footer={null}
                       mask={true}
                       title={imageLibraryStore.detailType === DetailType.ADD ? "新增" : "编辑"}
                       maskClosable={true}>
                    <ImageEdit onSuccess={onEditSuccess}/>
                </Modal>
                <Modal onCancel={onUploadClose}
                       width={"500px"}
                       open={imageLibraryStore.isShowUpload}
                       closable={true}
                       centered={true}
                       destroyOnClose={true}
                       footer={null}
                       mask={true}
                       maskClosable={true}>
                    <UploadFile onSuccess={onUploadSuccess} funType={ExcelUploadType.ATLAS}/>
                </Modal>
                <Modal onCancel={onDeleteConfirmClose}
                       onOk={deleteButton}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={imageLibraryStore.isShowDeleteConfirm}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认删除该数据</div>
                </Modal>
            </Content>
        </Layout>
    );
}

export default observer(ImageLibrary);

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    line-height: 16px;
    text-align: center;
    color: #333333;
    font-weight: 450;
    margin-left: 15px;
  }
`;
const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }

    .ant-table-body {
      overflow-x: scroll !important;
    }

    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

    ::-webkit-scrollbar {
      width: 0px;
      height: 10px !important;
    }
  }
`;
const SearchWrapper = styled.div`
  & {
    margin: 15px 15px 0 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
  }
`;
